import { SetStateAction, useState } from "react";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import UnForm from "../../../../../Form";
import {
    faExclamationTriangle,
    faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import { IListarCasoResponse } from "../../../../../../Interfaces/Vendas/Caso/CasoInterface";
import { CadastrarCasoAtividadeController } from "../../../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { useUserInfor } from "../../../../../../Context/User";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IHistoricoWhatsapp {
    setShow: (value: SetStateAction<boolean>) => void;
    updateList?: () => void;
    caso?: IListarCasoResponse;
}

export default function HistoricoWhatsapp(props: IHistoricoWhatsapp) {
    const { Atendimento, lstInforVendas } = useAtendimentoPage();
    const { UserInfor, getConfigGeralVendas } = useUserInfor();
    const { ReloadHistorico } = useHistoricoContext();

    const [showAlert, setShowAlert] = useState(false);

    const configVendas = getConfigGeralVendas?.find(
        (config) =>
            config.DS_OBSERVACAO === "Código da Atividade do Tipo WhatsApp"
    )?.VL_CONFIGURACAO;

    const {
        execute: cadastrarCasoAtividade,
        loading: cadastrarCasoAtividadeLoading,
    } = useAsyncCallback(CadastrarCasoAtividadeController);

    function UrlWhatsApp() {
        const formatPhoneNumber = (phone: string) => {
            return phone
                .replace("+", "")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "");
        };

        if (lstInforVendas?.CONTA?.NR_TELEFONE) {
            const phone = lstInforVendas.CONTA.NR_TELEFONE;
            return `https://api.whatsapp.com/send?phone=${
                phone.includes("+55")
                    ? formatPhoneNumber(phone)
                    : "55" + formatPhoneNumber(phone)
            }`;
        } else if (props.caso?.NR_TELEFONE) {
            const phone = props.caso.NR_TELEFONE;
            return `https://api.whatsapp.com/send?phone=${
                phone.includes("+55")
                    ? formatPhoneNumber(phone)
                    : "55" + formatPhoneNumber(phone)
            }`;
        } else {
            return "";
        }
    }

    function handleSubmit(formData: any) {
        if (!configVendas) {
            setShowAlert(true);
            return;
        }

        cadastrarCasoAtividade({
            DS_HISTORICO: formData.DS_NOTA,
            DT_CASO_ATIVIDADE: moment().format("YYYY-MM-DDTHH:mm"),
            DT_CONCLUSAO: formData.DT_CONCLUSAO || undefined,
            DT_DURACAO: formData.DT_DURACAO || undefined,
            FL_CONCLUIDO: true,
            ID_CASO: Atendimento?.ID_CASO
                ? Atendimento?.ID_CASO
                : props.caso?.ID_CASO ?? 0,
            ID_CASO_ATIVIDADE: 0,
            ID_TIPO_ATIVIDADE: Number(configVendas) ?? 0,
            ID_USUARIO_CADASTRADO: 0,
            ID_USUARIO_RESPONSAVEL: UserInfor.ID_USUARIO ?? 0,
            VL_CUSTO: 0,
        })
            .then(() => {
                window.open(`${UrlWhatsApp()}&text=${formData.DS_NOTA}`);
            })
            .finally(() => {
                props.setShow(false);
                if (ReloadHistorico) ReloadHistorico();
                if (props.updateList) props.updateList();
            });
    }

    return (
        <UnForm handleSubmit={handleSubmit}>
            <label>
                Nota <span className="text-danger">*</span>
            </label>
            <UnForm.Textarea name="DS_NOTA" required />
            {showAlert && (
                <div
                    className="bg-light-danger text-danger rounded mt-2 p-3"
                    role="alert"
                >
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="mr-2"
                    />
                    Configuração geral de código da Atividade do Tipo WhatsApp
                    não preenchida. Por favor, preencha antes de enviar.
                </div>
            )}
            <UnForm.SubmitButton
                color="success"
                icon={faPaperPlane}
                loading={cadastrarCasoAtividadeLoading}
                loadingSize="sm"
                disabled={
                    cadastrarCasoAtividadeLoading ||
                    (lstInforVendas?.CONTA.NR_TELEFONE.length === 0 &&
                        lstInforVendas?.CONTA.NR_TELEFONE === "")
                }
                wrapperClassName="p-0 my-2 d-flex justify-content-end"
            >
                Enviar
            </UnForm.SubmitButton>
        </UnForm>
    );
}
